const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 285c11.046 0 20-8.954 20-20V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v245c0 11.046 8.954 20 20 20Z",
    style: {
      fill: "#d73a1f",
      fillRule: "nonzero"
    },
    transform: "matrix(-.03906 0 0 -.03906 29 24.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.472 367.324.101.102c11.701 11.701 27.069 17.549 42.437 17.549 15.356 0 30.71-5.842 42.388-17.521L408.114 257.17c7.826-7.795 7.851-20.458.056-28.284-7.795-7.825-20.458-7.851-28.284-.056L269.142 339.142A19.872 19.872 0 0 1 255 345a19.869 19.869 0 0 1-14.102-5.817L132.243 228.959c-7.754-7.867-20.418-7.957-28.284-.203s-7.957 20.417-.203 28.284l108.716 110.284Z",
    style: {
      fill: "#d73a1f",
      fillRule: "nonzero"
    },
    transform: "matrix(-.03906 0 0 -.03906 29 24.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 412c-11.046 0-20 8.954-20 20 0 22.056-17.944 40-40 40H80c-22.056 0-40-17.944-40-40 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 44.112 35.888 80 80 80h352c44.112 0 80-35.888 80-80 0-11.046-8.954-20-20-20Z",
    style: {
      fill: "#d73a1f",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 .03906 9 9)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256 285c11.046 0 20-8.954 20-20V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v245c0 11.046 8.954 20 20 20Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 -.03906 49 24.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.472 367.324.101.102c11.701 11.701 27.069 17.549 42.437 17.549 15.356 0 30.71-5.842 42.388-17.521L408.114 257.17c7.826-7.795 7.851-20.458.056-28.284-7.795-7.825-20.458-7.851-28.284-.056L269.142 339.142A19.872 19.872 0 0 1 255 345a19.869 19.869 0 0 1-14.102-5.817L132.243 228.959c-7.754-7.867-20.418-7.957-28.284-.203s-7.957 20.417-.203 28.284l108.716 110.284Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 -.03906 49 24.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 412c-11.046 0-20 8.954-20 20 0 22.056-17.944 40-40 40H80c-22.056 0-40-17.944-40-40 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 44.112 35.888 80 80 80h352c44.112 0 80-35.888 80-80 0-11.046-8.954-20-20-20Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 .03906 49 9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.0b5c21788618f33e671e1d3af7b42a3c.svg";
export { ForwardRef as ReactComponent };